import QRCode from 'qrcode';
import type { QRCodeToDataURLOptions } from 'qrcode';

import { QRCodeParams, QRCodeResult } from '../interfaces/interface.qrcode';

const DEFAULT_OPTIONS = {
  errorCorrectionLevel: 'M' as const,
  type: 'image/png' as const,
  quality: 0.92,
  margin: 4,
  color: {
    dark: '#000000',
    light: '#FFFFFF',
  },
  width: 200,
};

export const generateQRCode = async (params: QRCodeParams): Promise<QRCodeResult> => {
  if (!params.url) {
    return {
      success: false,
      error: `url parameter is ${params.url} (expected non-empty string)`,
    };
  }

  try {
    const options: QRCodeToDataURLOptions = {
      errorCorrectionLevel: params.errorCorrectionLevel || DEFAULT_OPTIONS.errorCorrectionLevel,
      type: DEFAULT_OPTIONS.type,
      margin: params.margin !== undefined ? params.margin : DEFAULT_OPTIONS.margin,
      color: params.color
        ? {
            dark: params.color.dark || DEFAULT_OPTIONS.color.dark,
            light: params.color.light || DEFAULT_OPTIONS.color.light,
          }
        : DEFAULT_OPTIONS.color,
      width: params.widthPx || DEFAULT_OPTIONS.width,
    };

    const qrCodeDataUrl = await QRCode.toDataURL(params.url, options);
    return {
      success: true,
      dataUrl: qrCodeDataUrl,
    };
  } catch (err) {
    return {
      success: false,
      error: `${err.message}`,
    };
  }
};
